import script from "./translatedComment.vue?vue&type=script&setup=true&lang=js"
export * from "./translatedComment.vue?vue&type=script&setup=true&lang=js"

import "./translatedComment.vue?vue&type=style&index=0&id=37511d66&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37511d66"]])

export default __exports__